import {api} from "@/shared/api";

import {FeatureModuleSelectionBase, PaymentPeriod} from "./featureModuleSelectionBase";
import {FeatureModule} from "@/shared/timr";

const template = `
			<div class="user-input-header">
				<div class="user-count-container">
					<label class="user-count-label">
						<span data-text-large class="m-0">${messages["pricing.licensedUsersDialog.newLicensedUserCount.label"]}</span>
					</label>
					<input id="userNumberInput" class="flex-column form-control form-users-input" type="number" value="1" min="1">
				</div>
				<div class="payment-period-container">
					<label data-text-large class="m-0 align-content-center">${messages["pricing.selectionDialog.paymentPeriod"]}</label>
					<div class="ml-15 btn-group">
						<button id="priceMonthlyButton" class="btn btn-default">${messages["pricing.selectionDialog.paymentPeriod.MONTHLY"]}</button>
						<button id="priceYearlyButton" class="btn btn-primary">${messages["pricing.selectionDialog.paymentPeriod.ANNUALLY"]}</button>
					</div>
				</div>
			</div>
			<div class="flex-row ml-0" id="pricePerMonth" data-too-much-users-not-visible></div>
			<div class="mt-20" data-too-much-users-not-visible>
				<div>
					<div id="baseFeatureModules">
					</div>
					<h4 id="extensionFeatureModulesHeader" style="display:none">${messages["pricing.selectionDialog.extensionModules"]}</h4>
					<div id="extensionFeatureModules" class="feature-module-grid-view">
					</div>
				</div>
			</div>
			<div class="mt-20" style="display: none" data-too-much-users-visible>
				<div class="panel panel-feature-module-item ml-auto mr-auto">
					<h1 class="text-bold mt-0">${messages["pricing.featureModuleSelection.discounts"]}</h1>
					<h5 class="m-0 text-bold">${messages["pricing.featureModuleSelection.discounts.label"]}</h5>
					<ul class="module-selector-feature-list ml-0 text-size-large">
						<li>${messages["pricing.featureModuleSelection.discounts.individualQuote"]}</li>
						<li>${messages["pricing.featureModuleSelection.discounts.yourRequirements"]}</li>
					</ul>
					<a href="${messages["pricing.featureModuleSelection.discounts.personalOffer.link"]}" class="btn btn-primary btn-personal-offer mt-15">
						${messages["pricing.featureModuleSelection.discounts.personalOffer"]}
					</a>
				</div>
			</div>
			`;

/**
 * Custom web component that draws the content of the feature module selection.
 */
export class FeatureModuleSelectionUserInput extends FeatureModuleSelectionBase {

	protected connectedCallback() {
		this.innerHTML = template;
		this.loadConfig()
			.then(() => {
				this.buildFeatureModuleItems(this.config, {
					switcheryClass: "switchery-xl",
					showFeatureViewOnInitialization: false
				});
				this.onFeatureModuleSelected();
				this.initUserNumberInput();
			})
			.catch(() => {
			});
	}

	protected buildMonthlyYearlySwitch(): void {
		this.initMonthlyYearlySwitch("#priceMonthlyButton", "#priceYearlyButton");
	}

	protected buildModalFooter(): void {
		// no footer needed
	}

	private async loadConfig(): Promise<void> {
		await api("pricing.json", false, false)
			.get()
			.done(data => {
				this.config = data;
			});
	}

	private initUserNumberInput(): void {
		document.querySelectorAll<HTMLElement>("[data-too-much-users-visible]").forEach(e => e.style.display = "none");
		const userNumberInput = document.getElementById("userNumberInput") as HTMLInputElement;
		userNumberInput.addEventListener("change", () => {
			const users = Math.max(1, Number(userNumberInput.value) || 1);
			if (users >= 20) {
				document.querySelectorAll<HTMLElement>("[data-too-much-users-not-visible]").forEach(e => e.style.display = "none");
				document.querySelectorAll<HTMLElement>("[data-too-much-users-visible]").forEach(e => e.style.display = "");
			} else {
				document.querySelectorAll<HTMLElement>("[data-too-much-users-not-visible]").forEach(e => e.style.display = "");
				document.querySelectorAll<HTMLElement>("[data-too-much-users-visible]").forEach(e => e.style.display = "none");
			}
			userNumberInput.valueAsNumber = users;

			this.updatePricePerUser(this.getSelectedModules());
		});
	}

	protected updatePricePerUser(selectedModules: FeatureModule[]) {
		this.calculatePricePerUserRequest?.abort();
		this.calculatePricePerUserRequest = api("calculatePricePerMonth.json", false, false)
			.get({
				selectedModuleIds: selectedModules.map((fm) => fm.id),
				users: Math.max(1, Number((document.getElementById("userNumberInput") as HTMLInputElement).valueAsNumber) || 1)
			})
			.done(data => {
				document.getElementById("pricePerMonth").innerHTML = this.formatPricePerUser(data.monthlyPrice, data.yearlyPrice);
			});
	}

	protected toggleSaveButton(selectedModules: FeatureModule[]): void {
		const btn: HTMLButtonElement = document.querySelector(".saveButton");
		btn.toggleAttribute("disabled", !(selectedModules.length > 0 || btn.disabled));
	}

	protected updateFeatureModulePrice(billingCycle: PaymentPeriod): void {
		this.calculateFeatureModulePriceRequest?.abort();
		this.calculateFeatureModulePriceRequest = api("calculateFeatureModulePrice.json", false, false)
			.get({
				featureModuleIds: this.getFeatureModuleItems().map((fm) => fm.featureModule.id),
				selectedModuleIds: this.getSelectedModules().map((fm) => fm.id),
				billingCycle: billingCycle
			})
			.done(results => {
				results.forEach(result => {
					const featureModuleItem = this.getFeatureModuleItems().find((fmi) => fmi.featureModule.id === result.featureModuleId);
					if (featureModuleItem) {
						featureModuleItem.updatePrice(result.basePrice, result.pricePerUser);
						featureModuleItem.updateDiscountInfo(result.discountResult);
					}
				});
			});
	}

}
